module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('c-loader', {
    staticClass: "c-project-list"
  }) : _c('ul', {
    class: _vm.modifier ? 'c-services-list c-services-list--' + _vm.modifier : 'c-services-list'
  }, _vm._l((_vm.services), function(service) {
    return _c('li', {
      staticClass: "c-services-list__item"
    }, [_c('router-link', {
      key: service.slug,
      staticClass: "c-services-list__link",
      attrs: {
        "to": _vm.settings.currentLang === 'en-us' ? '/en/service/' + service.slug : '/service/' + service.slug
      }
    }, [_c('span', {
      staticClass: "c-services-list__image"
    }, [(_vm.modifier === 'inverted') ? _c('img', {
      attrs: {
        "src": service.iconInverted,
        "alt": "Service Icon"
      }
    }) : _c('img', {
      attrs: {
        "src": service.icon,
        "alt": "Service Icon"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "c-services-list__label"
    }, [_vm._v(_vm._s(service.title))])])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b189d5b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServicesList.vue
// module id = 269
// module chunks = 0